import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service'
import { Router } from '@angular/router'

@Component({
	selector: 'app-terms-and-conditions',
	templateUrl: './terms-and-conditions.component.html',
	styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {
	isConfirmed:boolean[] = [false, false]

	constructor(
		private router: Router,
		private shared: SharedService,
	) { 
		this.shared.blockRefresh()
	}

	ngOnInit(): void {
	}

	onPrevious(): void {
		this.router.navigateByUrl('/product')
	}

	onNext(): void {
		this.router.navigateByUrl('/personal-info')
	}
}
